<template>
  <div style="width: 100%;background: #fff;box-sizing:border-box;flex-shrink:0;">
    <div class="header-box">
      <div class="header-top"
           style="width: 100%; height: 40px; z-index: 99999;  position: absolute; top: 5px; font-size: 16px;">
        <div style="width: 1200px; margin: 0 auto; height: 30px; line-height: 30px; text-align:right">
          <span style="font-weight: bold; float: left;cursor: pointer;    color: rgb(0 66 152); letter-spacing: 5px;"> 特资信大模型·特殊资产价值智评系统 </span>
          <span style="cursor: pointer;margin-right: 10px;font-weight: bold;"><router-link to="/about"> 关于我们</router-link></span>
          <span style="cursor: pointer;margin-right: 10px;font-weight: bold;" v-if="!show()" @click="zc">注册</span>
          <i></i>
          <span style="cursor: pointer;font-weight: bold;" v-if="!show()" @click="login">登录</span>
          <i></i>
          <span style="cursor: pointer;font-weight: bold;margin-right: 10px" v-if="show()" @click="cz">充值中心</span>
          <i></i>
          <span style="cursor: pointer;font-weight: bold;margin-right: 10px" v-if="show()" @click="user">个人中心</span>
          <i></i>
          <span style="cursor: pointer;font-weight: bold;" v-if="show()" @click="loginout">退出</span>

        </div>
      </div>
    </div>
    <div class="nav-wrapper" style="margin-top: -12px">
      <nav class="nav-menu-box">
        <ul class="star-list">
          <li>
            <router-link to="/" @click.native="navMenuClick()">首页</router-link>
          </li>
          <!--          <li>-->
          <!--            <router-link to="/report" @click.native="navMenuClick()">供应链信用</router-link>-->
          <!--          </li>-->
          <!--          <li>-->
          <!--            <router-link to="/me" @click.native="navMenuClick()">关于我们</router-link>-->
          <!--          </li>-->
        </ul>
      </nav>

    </div>

    <!--    <div class="header-location-box" v-if="headerTitle!=''">-->
    <!--    <div style="width: 1200px;margin: 0 auto;">-->
    <!--      <span>当前位置：<a href="/"> 首页 </a> &gt; {{headerTitle}} </span>-->
    <!--    </div>-->
    <!--    </div>-->
  </div>

</template>

<script>
import {mapActions} from "vuex"
import router from "@/router";

export default {
  name: 'Header',
  props: {},
  data() {
    return {
      isMinScreen: this.$root.$data.isMinScreen,
      headerTitle: "",
    }
  },
  created() {
    router.beforeEach((to, from, next) => {
      if (to.meta.title === "首页") {
        this.headerTitle = "";
      } else {
        this.headerTitle = to.meta.title;
      }
      next();
    })

  },
  watch: {
    //监听是否是小窗口界面
    "$root.$data.isMinScreen": function (val) {
      if (typeof val === 'boolean') {
        this.isMinScreen = val
      }
      //非小屏幕
      if (!val) {
        document.getElementsByClassName('nav-menu-box').item(0).style.display = 'block'
        let listSubList = document.querySelectorAll('.start-list-sub')
        listSubList.forEach(function (v) {
          v.removeAttribute('style')
        })
      }
    },
  },
  methods: {
    //小窗口菜单显示逻辑
    showMobileNav() {
      let navDom = document.getElementsByClassName('nav-menu-box').item(0)
      navDom.style.display = (!navDom.style.display || navDom.style.display === 'none') ? "block" : "none"
    },
    subNavOpen(e) {
      let listSubList = document.querySelectorAll('.start-list-sub')
      listSubList.forEach(function (v) {
        if (v === e.currentTarget.previousElementSibling) {
          v.style.display = (v.style.display === 'block') ? "none" : "block"
        } else {
          v.style.display = 'none'
        }
      })
      //document.getElementsByClassName('nav-menu-box').item(0).style.display = 'none'
    },
    //菜单点击原生事件
    navMenuClick() {
      if (this.isMinScreen) {
        document.getElementsByClassName('nav-menu-box').item(0).style.display = 'none'
      }
    },
    //搜索页面
    showSearchPage() {
      this.$router.push('/m-search')
    },
    zc() {
      this.$router.push('/register')
    },
    login() {
      this.$router.push('/login')
    },
    cz() {
      this.$router.push('/pay')
    },
    user() {
      this.$router.push('/user')
    },
    ...mapActions(["Logout"]),
    loginout() {
      const that = this
      that.Logout({}).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.message)
          this.$router.push('/')
        } else {
          this.$message.error(res.message)
        }
      });
    },
    show() {
      if (this.$store.state.token) {
        return true;
      }
      return false;
    }
  }
}
</script>

